import PropTypes from 'prop-types';

import { useInitRecaptcha } from '../../context/RecaptchaContext';

const noOp = () => {};

const ReCaptcha = ({ onChange, onExpired, onError = noOp, className = '' }) => {
  const { containerRef } = useInitRecaptcha({ onChange, onExpired, onError });

  return <div ref={containerRef} className={className} />;
};

ReCaptcha.propTypes = {
  onChange: PropTypes.func.isRequired,
  onExpired: PropTypes.func.isRequired,
  onError: PropTypes.func,
  className: PropTypes.string
};

export default ReCaptcha;
